import { render, staticRenderFns } from "./institucionesXCiudad.vue?vue&type=template&id=0ed48900&scoped=true"
import script from "./institucionesXCiudad.vue?vue&type=script&lang=js"
export * from "./institucionesXCiudad.vue?vue&type=script&lang=js"
import style0 from "./institucionesXCiudad.vue?vue&type=style&index=0&id=0ed48900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed48900",
  null
  
)

export default component.exports